(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["skiff-compatibility"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('skiff-compatibility')) {
    const feedCache = new Map();
    const cacheLifetime = 5 * 60 * 1000;
    const maxFeedAge = 3 * 24 * 60 * 60 * 1000;
    const pageSize = 50;
    const searchable = (text) => text.normalize('NFKD').replace(/[\u0300-\u036f]/g, '').toLowerCase();

    async function getFeed(url) {
      const cached = feedCache.get(url);
      if (cached && Date.now() - cached.createdAt < cacheLifetime) return cached.promise;
      const entry = { createdAt: Date.now() };
      entry.promise = (async () => {
        const response = await fetch(url, { credentials: 'omit', signal: AbortSignal.timeout(15000) });
        if (!response.ok) throw new Error('unavailable');
        const feed = await response.json();
        if (feed.schemaVersion !== 1 || !Array.isArray(feed.rows) || !feed.rows.length
          || feed.rows.length !== feed.rowCount || !Number.isFinite(Date.parse(feed.updatedAt))) {
          throw new Error('invalid');
        }
        const age = Date.now() - Date.parse(feed.updatedAt);
        if (age >= maxFeedAge || age < -300000) throw new Error('stale');
        for (const row of feed.rows) {
          if (typeof row.maker !== 'string' || typeof row.model !== 'string'
            || !['listed', 'not_listed', 'not_compatible'].includes(row.bearingStatus)
            || !['listed', 'not_listed', 'unresolved'].includes(row.washerStatus)
            || !Array.isArray(row.bearings) || !Array.isArray(row.washers)
            || [...row.bearings, ...row.washers].some((part) => typeof part?.name !== 'string' || !part.name)) {
            throw new Error('invalid');
          }
        }
        return feed;
      })().catch((error) => {
        if (feedCache.get(url) === entry) feedCache.delete(url);
        throw error;
      });
      feedCache.set(url, entry);
      return entry.promise;
    }

    class SkiffCompatibility extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        const { signal } = this.controller;
        this.input = this.querySelector('[data-skiff-search]');
        this.dropdown = this.querySelector('[data-skiff-dropdown]');
        this.isOpen = false;
        this.status = this.querySelector('[data-skiff-status]');
        this.results = this.querySelector('[data-skiff-results]');
        this.body = this.querySelector('[data-skiff-rows]');
        this.retry = this.querySelector('[data-skiff-retry]');
        this.more = this.querySelector('[data-skiff-more]');
        this.section = this.closest('.js-product');
        this.config = JSON.parse(this.querySelector('[data-skiff-config]').textContent);
        this.strings = this.config.strings;
        this.selectedId = String(this.config.selectedId);
        this.limit = pageSize;
        this.variants = new Map();
        this.byId = new Map();
        this.config.variants.forEach((variant) => {
          const key = variant.name.replace(/\s+/g, '');
          const matches = this.variants.get(key) || [];
          matches.push(variant);
          this.variants.set(key, matches);
          this.byId.set(String(variant.id), variant);
        });
        this.input.addEventListener('focus', () => this.openDropdown(), { signal });
        this.input.addEventListener('click', () => {
          if (!this.isOpen) this.openDropdown();
        }, { signal });
        this.input.addEventListener('input', () => {
          this.limit = pageSize;
          this.openDropdown();
        }, { signal });
        this.input.addEventListener('keydown', (event) => {
          if (event.key === 'Enter' || event.key === 'ArrowDown') {
            event.preventDefault();
            if (this.dropdown.hidden) this.openDropdown();
            else this.body.querySelector('a')?.focus();
          }
        }, { signal });
        this.addEventListener('keydown', (event) => {
          if (event.key !== 'Escape') return;
          event.preventDefault();
          this.input.focus({ preventScroll: true });
          this.closeDropdown();
        }, { signal });
        this.addEventListener('focusout', (event) => {
          if (event.relatedTarget && !this.contains(event.relatedTarget)) this.closeDropdown();
        }, { signal });
        document.addEventListener('pointerdown', (event) => {
          if (!this.contains(event.target)) this.closeDropdown();
        }, { signal });
        this.retry.addEventListener('click', () => this.loadFeed(), { signal });
        this.more.addEventListener('click', () => {
          this.limit += pageSize;
          this.render();
        }, { signal });
        this.body.addEventListener('click', (event) => this.selectResult(event), { signal });
        this.section?.addEventListener('on:variant:change', (event) => {
          if (event.target.closest('.js-product') !== this.section) return;
          this.selectedId = String(event.detail.variant?.id || '');
          this.updateSelected();
        }, { signal });
      }

      disconnectedCallback() {
        this.closeDropdown();
        this.controller?.abort();
        this.controller = null;
      }

      openDropdown() {
        this.isOpen = true;
        this.loadFeed();
      }

      closeDropdown() {
        this.isOpen = false;
        this.setDropdownVisible(false);
      }

      setDropdownVisible(visible) {
        this.dropdown.hidden = !visible;
        this.input.setAttribute('aria-expanded', String(visible));
      }

      async loadFeed() {
        if (this.rows && Date.now() - this.loadedAt < cacheLifetime) {
          this.render();
          return;
        }
        if (this.loading) {
          this.setDropdownVisible(this.isOpen && this.input.value.trim().length >= 2);
          return;
        }
        this.loading = true;
        this.retry.hidden = true;
        this.results.hidden = true;
        this.status.textContent = this.strings.loading;
        this.setDropdownVisible(this.isOpen && this.input.value.trim().length >= 2);
        this.input.setAttribute('aria-busy', 'true');
        try {
          const feed = await getFeed(this.dataset.feedUrl);
          this.rows = feed.rows.map((row) => ({ ...row, search: searchable(`${row.maker} ${row.model}`) }));
          this.loadedAt = Date.now();
          if (this.isConnected) this.render();
        } catch (error) {
          this.rows = null;
          if (this.isConnected) {
            this.status.textContent = this.strings[error.message === 'stale' ? 'stale' : 'error'];
            this.retry.hidden = false;
            this.setDropdownVisible(this.isOpen && this.input.value.trim().length >= 2);
          }
        } finally {
          this.loading = false;
          this.input.removeAttribute('aria-busy');
        }
      }

      render() {
        this.body.replaceChildren();
        this.results.hidden = true;
        this.status.textContent = '';
        this.setDropdownVisible(false);
        const query = this.input.value.trim();
        if (!this.isOpen || query.length < 2 || !this.rows) return;
        this.setDropdownVisible(true);
        const words = searchable(query).split(/\s+/).filter(Boolean);
        const washerMode = this.dataset.mode === 'washers';
        const matches = this.rows.filter((row) =>
          (!washerMode || (row.washerStatus === 'listed' && row.washers.length > 0))
          && words.every((word) => row.search.includes(word)));
        if (!matches.length) {
          this.status.textContent = this.strings.empty;
          return;
        }
        const visible = matches.slice(0, this.limit);
        const fragment = document.createDocumentFragment();
        visible.forEach((row) => {
          const tr = document.createElement('tr');
          const brand = document.createElement('td');
          const knife = document.createElement('td');
          const parts = document.createElement('td');
          this.addText(brand, row.maker, 'skiff-fit__maker');
          this.addText(knife, row.maker, 'skiff-fit__maker skiff-fit__mobile-brand');
          this.addText(knife, row.model, 'skiff-fit__model');
          if (row.notes) this.addText(knife, row.notes, 'skiff-fit__notes');
          const sourceStatus = washerMode ? row.washerStatus : row.bearingStatus;
          const items = washerMode ? row.washers : row.bearings;
          if (sourceStatus === 'listed' && items.length) {
            items.forEach((part) => this.addPart(parts, part.name));
          } else {
            const key = sourceStatus === 'not_compatible' ? 'incompatible' : 'not_listed';
            this.addText(parts, this.strings[key], 'skiff-fit__availability');
          }
          tr.append(brand, knife, parts);
          fragment.append(tr);
        });
        this.body.append(fragment);
        this.results.hidden = false;
        this.more.hidden = matches.length <= visible.length;
        this.updateSelected();
      }

      addText(parent, text, className) {
        const span = document.createElement('span');
        span.className = className;
        span.textContent = text;
        parent.append(span);
        return span;
      }

      addPart(cell, name) {
        const variants = this.variants.get(name) || [];
        const variant = variants.length === 1 ? variants[0] : null;
        const choice = document.createElement('div');
        choice.className = 'skiff-fit__choice';
        const control = document.createElement(variant ? 'a' : 'button');
        control.className = 'skiff-fit__part';
        control.textContent = name;
        if (variant) {
          control.href = variant.url;
          control.dataset.variantId = String(variant.id);
          const checkbox = this.querySelector('[data-skiff-checkbox]').content.cloneNode(true);
          checkbox.querySelectorAll('[id]').forEach((element) => element.removeAttribute('id'));
          control.prepend(checkbox);
        } else {
          control.type = 'button';
          control.disabled = true;
        }
        choice.append(control);
        if (!variant) {
          this.addText(choice, this.strings[variants.length ? 'ambiguous' : 'not_carried'], 'skiff-fit__availability');
        }
        if (variant) {
          const selected = this.addText(choice, this.strings.selected, 'skiff-fit__selected visually-hidden');
          selected.hidden = true;
        }
        cell.append(choice);
      }

      updateSelected() {
        this.body.querySelectorAll('a[data-variant-id]').forEach((link) => {
          const selected = link.dataset.variantId === this.selectedId;
          if (selected) link.setAttribute('aria-current', 'true');
          else link.removeAttribute('aria-current');
          link.parentElement.querySelector('.skiff-fit__selected').hidden = !selected;
        });
      }

      selectResult(event) {
        const link = event.target.closest('a[data-variant-id]');
        if (!link || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey || event.button !== 0) return;
        const variant = this.byId.get(link.dataset.variantId);
        const picker = this.section?.querySelector('variant-picker');
        if (!variant || !picker || typeof picker.getSelectedOptions !== 'function') return;
        // Some picker layouts omit the stock metadata the theme needs; use the variant URL instead.
        const pickerVariant = picker.data?.product.variants.find((item) => String(item.id) === String(variant.id));
        if (pickerVariant?.inventory_management && !this.section.querySelector(`#variant-${variant.id}`)) return;
        const selectors = picker.querySelectorAll('.option-selector');
        if (selectors.length !== 1) return;
        const selector = selectors[0];
        const option = Array.from(selector.querySelectorAll('.js-option')).find((item) =>
          (selector.dataset.selectorType === 'dropdown' ? item.dataset.value : item.value) === variant.name);
        if (!option) return;
        let selected = false;
        const confirm = (change) => { selected = String(change.detail.variant?.id) === String(variant.id); };
        picker.addEventListener('on:variant:change', confirm);
        try {
          if (selector.dataset.selectorType === 'dropdown') {
            const select = selector.querySelector('custom-select');
            if (typeof select?.selectOption !== 'function') return;
            if (picker.getSelectedOptions()[0] === variant.name) selected = true;
            else select.selectOption(option);
          } else {
            if (option.checked) selected = true;
            else option.click();
          }
        } finally {
          picker.removeEventListener('on:variant:change', confirm);
        }
        if (!selected) return;
        event.preventDefault();
        this.selectedId = String(variant.id);
        this.updateSelected();
        this.closeDropdown();
        const target = selector.querySelector('.custom-select__btn') || option;
        target.focus({ preventScroll: true });
        (selector.querySelector('.custom-select__btn') || option.nextElementSibling || option).scrollIntoView({ block: 'nearest' });
      }
    }

    customElements.define('skiff-compatibility', SkiffCompatibility);
  }
  } catch(e) { console.error(e); }
})();

})();
